<tui-root>
  <router-outlet></router-outlet>
</tui-root>
